interface SwoftLogoProps {
  size?: number;
  className?: string;
}

/**
 * Le logo Swoft, celui de nos propres applications.
 *
 * 🚨 Kevin, 2026-09-30 : l'ecran affichait un hexagone abstrait dessine pour
 * l'occasion. Le logo existe, il est dans `swoft-logomark.svg` du portail et
 * d'app-swoft, et c'est lui qu'il faut montrer : le carre arrondi en degrade
 * orange et ses trois points. Les couleurs et la geometrie sont reprises
 * telles quelles de ce fichier, pas approchees.
 *
 * L'identifiant du degrade porte la taille, sinon deux logos de tailles
 * differentes sur la meme page partageraient une definition et le second
 * disparaitrait.
 */
export function SwoftLogo({ size = 20, className }: SwoftLogoProps) {
  const id = `swoft-logo-${size}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 320 320"
      role="img"
      aria-label="Swoft"
      className={className}
    >
      <defs>
        <linearGradient id={`${id}-bg`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF4405" />
          <stop offset="100%" stopColor="#9E2E2E" />
        </linearGradient>
        <radialGradient id={`${id}-dot`} cx="35%" cy="30%" r="75%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="80%" stopColor="#FFE5D5" />
          <stop offset="100%" stopColor="#F7F8F5" />
        </radialGradient>
      </defs>
      <rect x="10" y="10" width="300" height="300" rx="58" ry="58" fill={`url(#${id}-bg)`} />
      <g transform="translate(160,160)">
        <circle cx="0" cy="-49.6" r="25.6" fill={`url(#${id}-dot)`} />
        <circle cx="-44.8" cy="25.6" r="25.6" fill={`url(#${id}-dot)`} />
        <circle cx="44.8" cy="25.6" r="25.6" fill={`url(#${id}-dot)`} />
      </g>
    </svg>
  );
}
